import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import Email from '../../containers/OldSTLandingPage/sections/QuickMenu/icons/Email';

import css from './ListingContactModal.module.css';
import Modal from './components/Modal/Modal';

const whatsappIcon = 'https://res.cloudinary.com/dlcacck3a/image/upload/v1769082637/socialbnb/assets/icons/whatsapp-icon2.png';

const ListingContactModal = props => {
  const { isOpen, onClose } = props;

  const handleClose = useCallback(
    e => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      onClose();
    },
    [onClose]
  );

  const whatsappNumber = '+4915730977660';
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  
  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <div className={css.modalContent}>
        <h2 className={css.modalTitle}>
          <FormattedMessage id="ListingPage.contactModalTitle" />
        </h2>
        <p className={css.modalMessage}>
          <FormattedMessage id="ListingPage.contactModalMessage" />
        </p>
        <div className={css.contactButtons}>
          <a
            href="mailto:booking@socialbnb.de"
            className={css.contactButton}
            onClick={e => e.stopPropagation()}
          >
            <Email width={28} height={28} />
          </a>
          <div className={css.whatsappContent}>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className={css.contactButton}
            >
              <img src={whatsappIcon} className={css.whatsappIcon} alt="WhatsApp Icon" />
            </a>
          </div>
        </div>
        <div className={css.modalButtons}>
          <button onClick={handleClose} className={css.closeButton} type="button">
            <FormattedMessage id="ListingPage.close" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ListingContactModal;
